/** O nome que o sistema da a uma campanha recem-criada. */
export const NOME_PADRAO = 'Campanha sem nome';

interface Estado {
  name: string;
  body: string;
  total: number;
  /** So campanha ativa dispara - e a API recusa as demais. */
  ativa: boolean;
  /** Ha edicao na tela que ainda nao foi gravada. */
  alterado: boolean;
  /**
   * O modelo escolhido ja passou pela Meta. Sem ele o disparo em massa nao
   * sai: fora das 24h a Meta so entrega texto que aprovou antes.
   */
  modeloAprovado?: boolean;
}

/**
 * Uma coisa que falta, e onde ela se resolve. O passo vem junto do texto para
 * a tela poder levar ate ele - dizer "falta o nome" sem dizer onde e metade
 * do recado.
 */
export interface Pendencia {
  texto: string;
  /** Indice do passo que resolve; nulo quando e so gravar o que esta na tela. */
  passo: number | null;
}

/** Os passos, na ordem em que aparecem na tela. */
export const PASSO = { DADOS: 0, PUBLICO: 1, MENSAGEM: 2 } as const;

/**
 * O que ainda falta para a campanha poder sair, passo a passo - para a Steps
 * e o botao Disparar levarem ate onde falta resolver.
 */
export function pendenciasDaCampanha({
  name,
  body,
  total,
  ativa,
  alterado,
  modeloAprovado = true,
}: Estado): Pendencia[] {
  const pendencias: Pendencia[] = [];

  if (!name.trim() || name.trim() === NOME_PADRAO) {
    pendencias.push({ texto: 'De um nome a campanha', passo: PASSO.DADOS });
  }
  if (!body.trim()) pendencias.push({ texto: 'Escreva a mensagem', passo: PASSO.MENSAGEM });
  if (!modeloAprovado) {
    pendencias.push({ texto: 'Use um modelo aprovado pela Meta', passo: PASSO.MENSAGEM });
  }
  if (total === 0) {
    pendencias.push({ texto: 'Nenhum cliente atende aos filtros', passo: PASSO.PUBLICO });
  }
  if (!ativa) pendencias.push({ texto: 'Mude a situacao para Ativa', passo: PASSO.DADOS });
  if (alterado) pendencias.push({ texto: 'Salve as alteracoes', passo: null });

  return pendencias;
}

export interface ItemDoChecklist {
  /** `ativa` e `salvo` valem para o disparo; ativar a campanha nao os exige. */
  key: 'nome' | 'mensagem' | 'publico' | 'ativa' | 'salvo';
  label: string;
  ok: boolean;
}

/**
 * O mesmo caminho ate o disparo, em formato de checklist marcavel - o modal
 * de "o que falta" precisa do ok/nao-ok, nao de para onde navegar.
 */
export function checklistDaCampanha({
  name,
  body,
  total,
  ativa,
  alterado,
}: Estado): ItemDoChecklist[] {
  return [
    {
      key: 'nome',
      label: 'De um nome a campanha',
      ok: !!name.trim() && name.trim() !== NOME_PADRAO,
    },
    { key: 'mensagem', label: 'Escreva a mensagem', ok: !!body.trim() },
    { key: 'publico', label: 'Ter ao menos um destinatario', ok: total > 0 },
    { key: 'ativa', label: 'Mude a situacao para Ativa', ok: ativa },
    { key: 'salvo', label: 'Salve as alteracoes', ok: !alterado },
  ];
}
